<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn to="/manage-courses" color="error" exact icon flat>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 headline">Create A Course</v-toolbar-title>
  </v-toolbar>
    
  <v-layout row wrap justify-center>
    <v-flex class="px-3 pb-2" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex class="px-2 pb-3" xs12 md10 lg8>
      <v-layout row wrap justify-center>
        <v-flex class="px-2 pb-3" xs12 md7>
          <v-select
            label="Live or Online?"
            v-model="newCourse.type"
            @blur="updateName"
            :items="['Live', 'Online']"
            :disabled="!newCourse.type == ''"
            hide-details
          ></v-select>
        </v-flex>
        <v-flex class="px-2 pb-3" xs12>
          <v-text-field
            label="Course Name"
            v-model="newCourse.name"
            :disabled="newCourse.type == ''"
            :readonly="newCourse.type == 'Live'"
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex class="px-2 pb-3" xs6 md3>
          <v-select
            label="Course Subject"
            v-model="newCourse.subject"
            @blur="updateName"
            :items="['RN', 'PN']"
            :disabled="newCourse.type == ''"
            hide-details
          ></v-select>
        </v-flex>
        <v-flex class="px-2 pb-3" xs6 md3>
          <v-text-field
            label="Course Price"
            v-model="newCourse.price"
            :disabled="newCourse.type == ''"
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex class="px-2 pb-3" xs6 md3>
          <v-text-field
            label="# of Days Online"
            v-model="newCourse.onlineDays"
            @blur="updateName"
            :disabled="newCourse.type == ''"
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex class="px-2 pb-3" xs6 md3>
          <v-text-field
            label="# of Live Classes"
            v-model="live"
            @blur="updateName"
            hide-details
            disabled
          ></v-text-field>
        </v-flex>
        <v-flex class="px-2 pb-3" xs12>
          <v-select
            label="Content"
            v-model="newCourse.content"
            :items="allContent"
            :disabled="newCourse.type == ''"
            hide-details
            multiple
            chips
          ></v-select>
        </v-flex>
        <template v-if="newCourse.type == 'Live'">
          <v-flex class="px-2 pb-3" xs6 md3>
            <v-select
              label="Instructor"
              v-model="newCourse.instructor"
              :items="['Ms. Mo', 'ONLINE']"
              hide-details
              readonly
            ></v-select>
          </v-flex>
          <v-flex class="px-2 pb-3" xs6 md3>
            <v-menu
              ref="startTimeMenu"
              :close-on-content-click="false"
              v-model="startTimeMenu"
              :nudge-right="40"
              :return-value.sync="startTime"
              transition="scale-transition"
              min-width="290px"
              max-width="290px"
              offset-y
              full-width
              lazy>
              <v-text-field
                label="Start Time"
                slot="activator"
                v-model="newCourse.startTime"
                hide-details
                readonly
              ></v-text-field>
              <v-time-picker
                v-model="startTime"
                @change="$refs.startTimeMenu.save(startTime), updateName()"
              ></v-time-picker>
            </v-menu>
          </v-flex>
          <v-flex class="px-2 pb-3" xs6 md3>
            <v-menu
              ref="endTimeMenu"
              :close-on-content-click="false"
              v-model="endTimeMenu"
              :nudge-right="40"
              :return-value.sync="endTime"
              transition="scale-transition"
              min-width="290px"
              max-width="290px"
              offset-y
              full-width
              lazy>
              <v-text-field
                label="End Time"
                slot="activator"
                v-model="newCourse.endTime"
                hide-details
                readonly
              ></v-text-field>
              <v-time-picker
                v-model="endTime"
                @change="$refs.endTimeMenu.save(endTime), updateName()"
              ></v-time-picker>
            </v-menu>
          </v-flex>
          <v-flex class="px-2 pb-3" xs6 md3>
            <v-text-field
              label="Max. # of Students"
              v-model="newCourse.maxStudents"
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex class="px-2 pb-3" xs12>
            <v-text-field
              label="Course Location"
              v-model="newCourse.location"
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex class="px-2 pb-1" xs12>
            <v-select
              label="Dates"
              v-model="newCourse.dates"
              :items="newCourse.dates"
              append-icon="backspace"
              :append-icon-cb="() => (removeDate())"
              hide-details
              multiple
              chips
              readonly
            ></v-select>
          </v-flex>
          <v-flex class="px-2 pb-1 text-xs-center" xs12>
            <v-menu
              :close-on-content-click="false"
              v-model="pickingDate"
              transition="scale-transition"
              :nudge-right="40"
              min-width="290px"
              :return-value.sync="dateChoice"
              full-width
              offset-y
              lazy>
              <v-btn
                slot="activator"
                color="primary"
                class="my-0"
                depressed
                small>Add Dates</v-btn>
              <v-date-picker v-model="dateChoice" no-title scrollable>
                <v-btn @click="addDate" color="success" depressed small>Add</v-btn>
                <v-btn @click="pickingDate = false" color="error" flat small>Close</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
        </template>
        <v-flex class="px-1 pt-2 pb-3 text-xs-center" xs12>
          <v-btn @click.native="canCreate" :loading="creating" :disabled="creating || newCourse.type == ''" color="success" depressed large>
            Create
          </v-btn>
          <v-btn @click.native="popup.show = true, popup.type='Resetting'" :disabled="newCourse.type == ''" color="error" flat large>
            <b>Reset</b>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>

  <r-course-popup
    :popup="popup"
    :new-course="newCourse"
  ></r-course-popup>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
import CoursePopup from './CoursePopup.vue'
import {coursesEvent} from '../../main'
export default {
  components: {
    rCrumbs: Crumbs,
    rCoursePopup: CoursePopup
  },
  data: () => ({
    loading: false,
    creating: false,
    pickingDate: false,
    dateChoice: null,
    startTimeMenu: false,
    startTime: null,
    endTimeMenu: false,
    endTime: null,
    allCourses: [],
    allContent: [],
    newCourse: {},
    live: '',
    popup: {
      show: false,
      type: ''
    }
  }),
  beforeMount () {
    coursesEvent.$off()
    this.load()
    coursesEvent.$on('reset', () => {
      this.resetNewCourse()
    })
    coursesEvent.$on('createCourse', () => {
      this.createCourse()
    })
  },
  beforeDestroy () {
    this.$store.dispatch('setCourseToCopy', null)
  },
  methods: {
    load () {
      this.loading = true
      this.resetNewCourse()
      this.allCourses = this.$store.getters.courses
      const c = [...this.$store.getters.content]
      for (let content of c) {
        this.allContent.push(content.name)
      }
      this.loading = false
    },
    resetNewCourse () {
      if (this.$store.getters.courseToCopy) {
        let courseToCopy = this.$store.getters.courseToCopy
        this.newCourse = {
          ...courseToCopy,
          content: [],
          price: '',
          onlineDays: ''
        }
        for (let c of courseToCopy.content) {
          this.newCourse.content.push(this.$store.getters.contentByKey(c).name)
        }
      } else {
        this.newCourse = {
          type: '',
          name: '',
          subject: '',
          price: '0',
          onlineDays: '0',
          instructor: 'Ms. Mo',
          startTime: '',
          endTime: '',
          maxStudents: '',
          location: '',
          content: [],
          dates: [],
          published: false
        }
      }
    },
    canCreate () {
      const digit = this.$store.getters.reg.digit
      const appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.newCourse.type === '' || this.newCourse.name === '') {
        appMsg.msg = this.newCourse.type === '' ? 'Please choose a course type' : 'Please enter a name for the course'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      } else if (this.newCourse.name.length < 3) {
        appMsg.msg = 'Course name has to be longer than 2 characters'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      if (this.newCourse.price === '') {
        appMsg.msg = 'Please enter a course price'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      } else if (!digit.test(this.newCourse.price) || parseInt(this.newCourse.price, 10) <= 0) {
        appMsg.msg = 'Please enter only numbers greater than 0 for course price'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      if (this.newCourse.onlineDays === '') {
        appMsg.msg = 'Please enter course Online Days in # of Days'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      } else if (!digit.test(this.newCourse.onlineDays) || parseInt(this.newCourse.onlineDays, 10) <= 0) {
        appMsg.msg = 'Please enter only numbers greater than 0 for course Online Days'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      if (this.newCourse.type === 'Live') {
        if (this.newCourse.location === '') {
          appMsg.msg = 'Please enter a location for the course'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        }
        if (this.newCourse.dates.length === 0 || this.newCourse.startTime === '' || this.newCourse.endTime === '') {
          appMsg.msg = this.newCourse.dates.length === 0 ? 'Please choose dates for the course' : 'Please enter course times'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        }
        if (this.newCourse.maxStudents === '') {
          appMsg.msg = 'Please enter max # of students allowed'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        } else if (!digit.test(this.newCourse.maxStudents) || parseInt(this.newCourse.maxStudents, 10) <= 0) {
          appMsg.msg = 'Please enter only numbers greater than 0 for max # of students'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        }
      }
      if (this.newCourse.type === 'Online' && this.newCourse.content.length === 0) {
        appMsg.msg = 'Please choose at least one content for the course'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      let modified = ''
      let otherModified = ''
      for (let course of this.allCourses) {
        if (course.type === 'Live') {
          modified = this.newCourse.name.split(' ').splice(1, this.newCourse.name.split(' ').length).join(' ')
          otherModified = course.name.split(' ').splice(1, course.name.split(' ').length).join(' ')
          if (modified === otherModified) {
            if (this.newCourse.maxStudents !== course.maxStudents) {
              appMsg.msg = 'A linkable course has a different Max Students value of ' + course.maxStudents
              this.$store.dispatch('showAppMsg', appMsg)
              return
            }
          }
        }
        if (this.newCourse.name.toLowerCase() === course.name.toLowerCase()) {
          let cNames = []
          for (let c of course.content) {
            cNames.push(this.$store.getters.contentByKey(c).name)
          }
          if (!this.$store.getters.arrayEquals(this.newCourse.content, cNames)) {
            appMsg.msg = 'A linkable course has a different course contents of ' + cNames
            this.$store.dispatch('showAppMsg', appMsg)
            return
          }
          if (this.newCourse.onlineDays === course.onlineDays) {
            appMsg.msg = 'An identical course already exists!'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          }
        }
      }
      this.popup = {
        show: true,
        type: 'Creating Course'
      }
    },
    createCourse () {
      this.creating = true
      if (this.newCourse.type === 'Online') {
        this.newCourse.liveClasses = '0'
        this.newCourse.dates = null
        this.newCourse.startTime = null
        this.newCourse.endTime = null
        this.newCourse.location = null
        this.newCourse.maxStudents = null
      }
      this.getContentKeys()
      for (let course of this.allCourses) {
        if (this.newCourse.name.toLowerCase() === course.name.toLowerCase() && this.$store.getters.arrayEquals(this.newCourse.content, course.content)) {
          if (this.newCourse.onlineDays === course.onlineDays) {
            const appMsg = {
              type: 'error',
              msg: 'An identical course already exists!'
            }
            this.$store.dispatch('showAppMsg', appMsg)
            this.creating = false
            this.newCourse.content = []
            return
          }
        }
      }
      this.$store.dispatch('createCourse', this.newCourse).then(() => {
        const appMsg = {
          type: 'success',
          msg: 'Course ' + this.newCourse.name + ' created!'
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.creating = false
        this.$router.push('/manage-courses')
      }).catch(err => {
        const appMsg = {
          type: 'error',
          msg: err.message
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.creating = false
      })
    },
    getContentKeys () {
      const c = this.$store.getters.content
      let names = [...this.newCourse.content]
      this.newCourse.content = []
      for (let name of names) {
        for (let content of c) {
          if (name === content.name) this.newCourse.content.push(content.key)
        }
      }
    },
    updateName () {
      if (this.newCourse.type === 'Live') {
        this.newCourse.name = ''
        if (this.newCourse.subject.toUpperCase() === 'RN' || this.newCourse.subject.toUpperCase() === 'PN') {
          this.newCourse.name += this.newCourse.subject.toUpperCase() + ' Review'
        } else this.newCourse.name += this.newCourse.subject.toUpperCase()
        if (this.newCourse.dates.length > 0) {
          let dateString = new Date(this.newCourse.dates[0]).toDateString().split(' ')
          this.newCourse.name += (' ' + dateString[1] + ' ' + dateString[2])
        }
        if (this.startTime) this.newCourse.startTime = this.formatTime(this.startTime).toLowerCase()
        if (this.endTime) this.newCourse.endTime = this.formatTime(this.endTime).toLowerCase()
        this.newCourse.name += ' ' + this.newCourse.startTime
      }
    },
    formatTime (time) {
      let timeString = ''
      let t = time.split(':')
      let hour = parseInt(t[0])
      let mins = parseInt(t[1])
      let dateTime = new Date(0, 0, 0, hour, mins, 0, 0)
      let timeParts = dateTime.toLocaleTimeString().split(' ')
      timeString = timeParts[0].split(':')
      timeString = timeString[0] + ':' + timeString[1] + timeParts[1]
      return timeString
    },
    addDate () {
      if (this.dateChoice) {
        this.newCourse.dates.push(new Date(this.dateChoice.split('-')).toLocaleDateString())
      }
      this.updateName()
    },
    removeDate () {
      this.newCourse.dates.pop()
      this.updateName()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/courses/CreateCourse.vue